// extracted by mini-css-extract-plugin
export default {"passed":"styles_passed__qGx5C","upcoming":"styles_upcoming__xaPwl","today":"styles_today__fQkH1"};